<!-- eslint-disable -->
<template>
  <CommonPages id="lender-details" :class="['lender-details-page']" :titlePrefix="lenderName"
    :metaDescription="domainConfig?.['meta']?.des || 'Default des'">
    <div class="lender-details-container"
      :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">

      <!-- 顶部蓝色背景区域 -->
      <div class="lender-header">
        <div class="lender-header-content">
          <div class="lender-logo-container" @click="navigateToPage('/all-lenders')">
            <img :src="lenderData.logoUrl " alt="Lender Logo" class="lender-logo">
            <div class="lender-rating">
              <img src="@/assets/icons/star.svg" alt="Star" class="rating-star">
              <span class="rating-value">{{ lenderData.rating }}</span>
            </div>
          </div>
          <div class="lender-info-container">
            <div class="lender-name-container" @click="navigateToPage('/all-lenders')">
              <h1 class="lender-name">{{ lenderData.name }}
              </h1>
              <div class="launch-time">Launch time：{{ lenderData.launchTime }}</div>
            </div>

            <AdComponent v-if="deviceType == 'mobile'"
              v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.detail_1"
              ref="ads-detail-1" class="ad-width-100 " :ads="adsensConfig?.detail_1"
              :showDebug="showDebug" />

            <div class="lender-description">
              {{ lenderData.description }}
            </div>
          </div>
        </div>
      </div>

      <!-- 贷款信息卡片区域 -->
      <div class="loan-info-cards">
        <div class="loan-info-card">
          <div class="card-icon-container">
            <div class="card-icon-bg">
              <img src="@/assets/icons/apr.svg" alt="APR" class="card-icon">
            </div>
          </div>
          <div class="card-content">
            <div class="card-label">APR from</div>
            <div class="card-value">{{ lenderData.aprFrom }}<span class="percentage">%</span></div>
          </div>
        </div>

        <div class="loan-info-card">
          <div class="card-icon-container">
            <div class="card-icon-bg">
              <img src="@/assets/icons/term.svg" alt="Term" class="card-icon">
            </div>
          </div>
          <div class="card-content">
            <div class="card-label">Loan term</div>
            <div class="card-value">{{ lenderData.loanTerm }} Mos</div>
          </div>
        </div>

        <div class="loan-info-card">
          <div class="card-icon-container">
            <div class="card-icon-bg">
              <img src="@/assets/icons/amount.svg" alt="Amount" class="card-icon">
            </div>
          </div>
          <div class="card-content">
            <div class="card-label">Loan amount</div>
            <div class="card-value">{{ lenderData.loanAmount }}</div>
          </div>
        </div>
      </div>

      <AdComponent v-if="deviceType == 'mobile'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.detail_2" ref="ads-detail-2"
        class="ad-width-100 m_padding" :ads="adsensConfig?.detail_2" :showDebug="showDebug" />

      <!-- 其他贷款机构推荐 -->
      <div class="other-lenders-section" v-if="deviceType == 'mobile'">
        <div class="other-lenders-header">
          <div class="other-lenders-header-title">Other Lenders</div>
          <div class="other-lenders-divider"></div>
        </div>
        <div class="other-lenders-container">
          <div class="lenders-cards-container">
            <div class="lenders-cards" :style="{ transform: `translateX(-${currentPage * 100}%)` }">
              <div v-for="(group, groupIndex) in lenderGroups" :key="groupIndex"
                class="lenders-group">
                <div v-for="(lender, index) in group" :key="index" class="lender-card"
                  @click="goToLenderDetails(lender)">
                  <div class="lender-logo-container-card">
                    <div class="lender-logo">
                      <img :src="lender.logoUrl" alt="Lender Logo" class="logo-img" />
                    </div>
                    <div class="lender-info">
                      <div class="lender-name">{{ lender.name }}</div>
                      <div class="lender-rating">
                        <img src="@/assets/icons/star.svg" alt="Rating" class="star-icon" />
                        <span>{{ lender.rating }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="divider"></div>
                  <div class="lender-details">
                    <div class="detail-item">
                      <div class="detail-icon apr-icon">
                        <img src="@/assets/icons/apr.svg" alt="APR" />
                      </div>
                      <div class="detail-content">
                        <div class="detail-label">APR from</div>
                        <div class="detail-value">{{ lender.apr }}</div>
                      </div>
                    </div>
                    <div class="detail-item">
                      <div class="detail-icon term-icon">
                        <img src="@/assets/icons/term.svg" alt="Term" />
                      </div>
                      <div class="detail-content">
                        <div class="detail-label">Loan term</div>
                        <div class="detail-value">{{ lender.term }}</div>
                      </div>
                    </div>
                    <div class="detail-item">
                      <div class="detail-icon amount-icon">
                        <img src="@/assets/icons/amount.svg" alt="Amount" />
                      </div>
                      <div class="detail-content">
                        <div class="detail-label">Loan amount</div>
                        <div class="detail-value">{{ lender.amount }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="navigation-controls">
              <div class="nav-button prev" @click="prevPage"
                :class="{ 'disabled': currentPage === 0 }">
                <img src="@/assets/icons/arrow-left.svg" alt="Previous" />
              </div>
              <div class="pagination-dots">
                <div v-for="(_, index) in lenderGroups" :key="index" class="pagination-dot"
                  :class="{ 'active': index === currentPage }" @click="goToPage(index)">
                </div>
              </div>
              <div class="nav-button next" @click="nextPage"
                :class="{ 'disabled': currentPage === lenderGroups.length - 1 }">
                <img src="@/assets/icons/arrow-right-small.svg" alt="Next" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="dashed"></div>

      <!-- 资格要求、优缺点部分 -->
      <div class="qualification-section">
        <div class="qualification-container">
          <div class="qualification-title">Known qualification requirements</div>
          <ul class="qualification-list">
            <li v-for="(item, index) in lenderData.qualifications" :key="index"
              class="qualification-item">
              {{ item }}
            </li>
          </ul>
        </div>

        <div class="qulification-dashed"></div>

        <div class="pros-cons-container">
          <div class="pros-container">
            <div class="pros-cons-title">Pros</div>
            <!-- <ul class="pros-list">
              <li v-for="(item, index) in lenderData.pros" :key="index" class="pros-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14.4C4.472 14.4 1.6 11.528 1.6 8C1.6 4.472 4.472 1.6 8 1.6C11.528 1.6 14.4 4.472 14.4 8C14.4 11.528 11.528 14.4 8 14.4ZM11.784 5.016L6.4 10.4L4.216 8.216C3.944 7.944 3.512 7.944 3.24 8.216C2.968 8.488 2.968 8.92 3.24 9.192L5.912 11.864C6.048 12 6.224 12.072 6.4 12.072C6.576 12.072 6.752 12 6.888 11.864L12.76 5.992C13.032 5.72 13.032 5.288 12.76 5.016C12.488 4.744 12.056 4.744 11.784 5.016Z"
                      fill="var(--theme-primary)" />
                  </svg>
                </div>
                <span>{{ item }}</span>
              </li>
            </ul> -->
            <div v-html="lenderData.pros" class="pros-item"></div>
          </div>

          <div class="cons-container">
            <div class="pros-cons-title">Cons</div>
            <!-- <ul class="cons-list">
              <li v-for="(item, index) in lenderData.cons" :key="index" class="cons-item">
                <div class="x-icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14.4C4.472 14.4 1.6 11.528 1.6 8C1.6 4.472 4.472 1.6 8 1.6C11.528 1.6 14.4 4.472 14.4 8C14.4 11.528 11.528 14.4 8 14.4ZM10.968 6.232C11.24 5.96 11.24 5.528 10.968 5.256C10.696 4.984 10.264 4.984 9.992 5.256L8 7.248L6.008 5.256C5.736 4.984 5.304 4.984 5.032 5.256C4.76 5.528 4.76 5.96 5.032 6.232L7.024 8.224L5.032 10.216C4.76 10.488 4.76 10.92 5.032 11.192C5.168 11.328 5.344 11.4 5.52 11.4C5.696 11.4 5.872 11.328 6.008 11.192L8 9.2L9.992 11.192C10.128 11.328 10.304 11.4 10.48 11.4C10.656 11.4 10.832 11.328 10.968 11.192C11.24 10.92 11.24 10.488 10.968 10.216L8.976 8.224L10.968 6.232Z"
                      fill="#FF4D4F" />
                  </svg>
                </div>
                <span>{{ item }}</span>
              </li>
            </ul> -->
            <div v-html="lenderData.cons" class="pros-item"></div>
          </div>
        </div>
      </div>

      <div class="dashed"></div>

      <!-- 摘要部分 -->
      <div class="summary-section">
        <div class="summary-title">Summary</div>
        <div class="summary-content">
          {{ lenderData.summary }}
        </div>
      </div>

      <div class="dashed"></div>

      <AdComponent v-if="deviceType != 'mobile'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.detail_1" ref="ads-detail-1"
        class="ad-width-100 pc_padding" :ads="adsensConfig?.detail_1" :showDebug="showDebug" />

      <AdComponent v-if="deviceType == 'mobile'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.detail_3" ref="ads-detail-3"
        class="ad-width-100 m_padding" :ads="adsensConfig?.detail_3" :showDebug="showDebug" />

      <!-- 其他贷款机构推荐 -->
      <div class="other-lenders-section" v-if="deviceType != 'mobile'">
        <div class="other-lenders-header">
          <div class="other-lenders-header-title">Other Lenders</div>
          <div class="other-lenders-divider"></div>
        </div>
        <div class="other-lenders-container">
          <div class="lenders-cards-container">
            <div class="lenders-cards" :style="{ transform: `translateX(-${currentPage * 100}%)` }">
              <div v-for="(group, groupIndex) in lenderGroups" :key="groupIndex"
                class="lenders-group">
                <div v-for="(lender, index) in group" :key="index" class="lender-card"
                  @click="goToLenderDetails(lender)">
                  <div class="lender-logo-container-card">
                    <div class="lender-logo">
                      <img :src="lender.logoUrl" alt="Lender Logo" class="logo-img" />
                    </div>
                    <div class="lender-info">
                      <div class="lender-name">{{ lender.name }}</div>
                      <div class="lender-rating">
                        <img src="@/assets/icons/star.svg" alt="Rating" class="star-icon" />
                        <span>{{ lender.rating }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="divider"></div>
                  <div class="lender-details">
                    <div class="detail-item">
                      <div class="detail-icon apr-icon">
                        <img src="@/assets/icons/apr.svg" alt="APR" />
                      </div>
                      <div class="detail-content">
                        <div class="detail-label">APR from</div>
                        <div class="detail-value">{{ lender.apr }}</div>
                      </div>
                    </div>
                    <div class="detail-item">
                      <div class="detail-icon term-icon">
                        <img src="@/assets/icons/term.svg" alt="Term" />
                      </div>
                      <div class="detail-content">
                        <div class="detail-label">Loan term</div>
                        <div class="detail-value">{{ lender.term }}</div>
                      </div>
                    </div>
                    <div class="detail-item">
                      <div class="detail-icon amount-icon">
                        <img src="@/assets/icons/amount.svg" alt="Amount" />
                      </div>
                      <div class="detail-content">
                        <div class="detail-label">Loan amount</div>
                        <div class="detail-value">{{ lender.amount }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="navigation-controls">
              <div class="nav-button prev" @click="prevPage"
                :class="{ 'disabled': currentPage === 0 }">
                <img src="@/assets/icons/arrow-left.svg" alt="Previous" />
              </div>
              <div class="pagination-dots">
                <div v-for="(_, index) in lenderGroups" :key="index" class="pagination-dot"
                  :class="{ 'active': index === currentPage }" @click="goToPage(index)">
                </div>
              </div>
              <div class="nav-button next" @click="nextPage"
                :class="{ 'disabled': currentPage === lenderGroups.length - 1 }">
                <img src="@/assets/icons/arrow-right-small.svg" alt="Next" />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import AdComponent from '@/pages/components/AdComponent.vue'
import '@/css/home.scss';
import '@/css/common.scss';

export default {
  name: 'LenderDetails',
  components: {
    CommonPages,
    AdComponent
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      currentPage: 0,
      lenderName: '',
      lenderData: {
        name: '',
        description: '',
        rating: '',
        launchTime: '',
        aprFrom: '',
        loanTerm: '',
        loanAmount: '',
        qualifications: [],
        pros: '',
        cons: '',
        summary: '',
        logo: ''
      },
      otherLenders: []
    };
  },
  computed: {
    ...mapGetters([
      'adsensConfig',
      'adPosConfig',
      'deviceType',
      'domainConfig',
      'showDebug'
    ]),
    lenderGroups () {
      const groups = [];
      for (let i = 0; i < this.otherLenders.length; i += 3) {
        groups.push(this.otherLenders.slice(i, i + 3));
      }
      return groups;
    }
  },
  created () {
    // 从路由获取贷款机构ID
    const { id, lenderName } = this.$route.params;
    this.lenderName = lenderName
    if (id) {
      this.lenderData.id = id;
      // 这里可以根据ID请求贷款机构数据
    }
  },
  async mounted () {
    if (this.lenderData.id) {
      this.fetchLenderData(this.lenderData.id);
    }

  },
  methods: {
    navigateToPage (path) {
      console.log(`navigateToPage: ${path}`);
      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        this.$router.push(`/${this.$route.params.channel}${path}`);
      } else {
        // 如果没有channel参数，直接导航
        this.$router.push(path);
      }
    },
    fetchLenderData (id) {
      console.log(`Fetching data for lender ID: ${id}`);
      this.$global.server.postAPI({
        method: 'get',
        url: `/car/Loans/carLoansInfo/${id}`,
      })
        .then(response => {
          if (response && response.data) {
            console.log('贷款机构信息获取成功:', response.data);
            // 处理主要贷款机构数据
            const carLoans = response.data.carLoans;
            if (carLoans) {
              this.lenderData = {
                id: carLoans.id,
                name: carLoans.lender,
                description: carLoans.introduction,
                rating: carLoans.rate,
                launchTime: this.formatDate(carLoans.createTime),
                aprFrom: carLoans.aprFrom,
                loanTerm: carLoans.loanTerm,
                loanAmount: carLoans.loanAmount,
                qualifications: carLoans.knownQualificationRequirements ?
                  carLoans.knownQualificationRequirements.split(',').map(item => item.trim()) : [],
                pros: carLoans.pros,
                cons: carLoans.cons,
                summary: carLoans.summary,
                logoUrl: carLoans.logoUrl || require('@/assets/default/placeholder.png')
              };
            }

            // 处理推荐列表数据
            if (response.data.recommendList && response.data.recommendList.length > 0) {
              this.otherLenders = response.data.recommendList.map(lender => {
                return {
                  id: lender.id,
                  name: lender.lender,
                  rating: lender.rate,
                  apr: lender.aprFrom,
                  term: lender.loanTerm + ' Mos',
                  amount: lender.loanAmount,
                  logoUrl: lender.logoUrl || require('@/assets/default/placeholder.png')
                };
              });
            }
          }
        })
        .catch(error => {
          console.error('获取贷款机构信息失败:', error);
        });
    },
    formatDate (dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.getFullYear();
    },
    prevPage () {
      if (this.currentPage > 0) {
        this.currentPage--;
      }
    },
    nextPage () {
      if (this.currentPage < this.lenderGroups.length - 1) {
        this.currentPage++;
      }
    },
    goToPage (index) {
      this.currentPage = index;
    },
    goToLenderDetails (lender) {
      if (lender.id === this.lenderData.id) return;

      const lenderNameSlug = lender.name.toLowerCase().replace(/\s+/g, '-');
      this.$router.push({
        name: 'LenderDetails',
        params: {
          lenderName: lenderNameSlug,
          id: lender.id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';
.pc_padding {
	padding: 0 rem(120);
}
// 全局主题颜色样式
.feature-card__icon,
.apply-button,
.pros-cons-wrapper:before,
.rate-item__icon,
.apply-now-button {
	background: var(--theme-primary) !important;
}

.lender-details {
	position: relative;
}

.lender-details-container {
	width: 100%;
}

.lender-details-page {
}

/* 顶部蓝色背景区域 */
.lender-header {
	background: url('~@/assets/detail-bg.png') no-repeat center center;
	// background-size: cover;
	background-size: 100% rem(130);
	background-position: top;
	width: 100%;
	height: rem(216);
	position: relative;

	.detect_deviece_mobile & {
		height: auto;
		background: url('~@/assets/detail-bg-mobile.png') no-repeat center center;
		background-size: 100% rem(130);
		padding-bottom: rem(20);
		background-position: top;
	}
}

.lender-header-content {
	padding: 0 rem(120);
	display: flex;
	flex-direction: row;
	gap: rem(24);
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	top: rem(56);

	.detect_deviece_mobile & {
		flex-direction: column;
		position: relative;
		left: 0;
		transform: none;
		padding: 0 rem(16);
		top: rem(20);
	}
}

.lender-logo-container {
	flex-shrink: 0;
	width: rem(160);
	height: rem(160);
	position: relative;
	cursor: pointer;

	.detect_deviece_mobile & {
		width: rem(160);
		height: rem(160);
		margin: 0 auto;
	}

	.lender-logo {
		background: #ccc;
		border-radius: rem(24);
		border: rem(3) solid var(--theme-primary);
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.lender-rating {
		background: linear-gradient(270deg, rgba(218, 161, 13, 1) 0%, rgba(246, 195, 63, 1) 100%);
		border-radius: 0 rem(16) 0 rem(24);
		padding: 0 rem(16);
		display: flex;
		flex-direction: row;
		gap: rem(8);
		align-items: center;
		justify-content: center;
		width: rem(72);
		height: rem(28);
		position: absolute;
		left: 0;
		bottom: 0;
	}

	.rating-star {
		width: rem(12);
		height: rem(12);
	}

	.rating-value {
		color: #ffffff;
		text-align: center;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 900;
	}
}

.lender-info-container {
	padding: rem(8) 0;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
	flex-shrink: 0;
	width: rem(975);
	height: rem(160);

	.detect_deviece_mobile & {
		width: 100%;
		height: auto;
		gap: rem(16);
		padding: rem(8) 0 rem(8) 0;
		align-items: center;
	}
}

.lender-name-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;

	.detect_deviece_mobile & {
		flex-direction: column;
		align-items: center;
		gap: rem(10);
	}
}

.lender-name {
	color: #ffffff;
	text-align: left;
	font-size: rem(52);
	line-height: rem(64);
	font-weight: 800;
	margin: 0;
	cursor: pointer;

	.detect_deviece_mobile & {
		font-size: rem(52);
		line-height: rem(64);
		color: #1a4048;
		text-align: center;
	}
}

.launch-time {
	background: #ffffff;
	border-radius: rem(8);
	padding: rem(8) rem(12);
	color: #1a4048;
	text-align: left;
	font-size: rem(14);
	line-height: rem(14);
	font-weight: 800;

	.detect_deviece_mobile & {
		font-size: rem(14);
		line-height: rem(14);
		background: rgba(26, 64, 72, 0.1);
	}
}

.lender-description {
	padding: rem(4) 0;
	color: #1a4048;
	text-align: left;
	font-size: rem(13);
	line-height: rem(20);
	font-weight: 400;
	width: 100%;

	.detect_deviece_mobile & {
		font-size: rem(13);
		line-height: rem(20);
		text-align: center;
	}
}

/* 贷款信息卡片区域 */
.loan-info-cards {
	padding: rem(36) rem(120) 0;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;

	.detect_deviece_mobile & {
		flex-direction: column;
		gap: rem(20);
		padding: rem(36) rem(16) rem(36) rem(16);
	}
}

.loan-info-card {
	border-radius: rem(24);
	border: rem(1) solid #e5e7eb;
	padding: rem(24);
	display: flex;
	flex-direction: row;
	gap: rem(16);
	align-items: flex-start;
	width: rem(380);

	.detect_deviece_mobile & {
		width: 100%;
		align-self: stretch;
	}
}

.card-icon-container {
	flex-shrink: 0;
	width: rem(56);
	height: rem(56);
	position: relative;
}

.card-icon-bg {
	background: var(--theme-primary);
	border-radius: rem(100);
	width: rem(56);
	height: rem(56);
	display: flex;
	align-items: center;
	justify-content: center;
}

.card-icon {
	width: rem(28);
	height: rem(28);
}

.card-content {
	display: flex;
	flex-direction: column;
	gap: rem(12);
}

.card-label {
	color: #1a4048;
	text-align: left;
	font-size: rem(16);
	line-height: rem(16);
	font-weight: 400;
}

.card-value {
	color: #1a4048;
	text-align: left;
	font-size: rem(28);
	line-height: rem(28);
	font-weight: 700;
}

.percentage {
	font-size: rem(28);
	line-height: rem(28);
	font-weight: 700;
}

.dashed {
	border-top: rem(1) dashed rgba(26, 64, 72, 0.3);
	margin: 0 rem(36);
	width: calc(100% - #{rem(240)});
	margin: rem(36) auto;

	.detect_deviece_mobile & {
		width: calc(100% - #{rem(32)});
		margin: rem(36) auto;
	}
}

/* 资格要求、优缺点部分 */
.qualification-section {
	display: flex;
	flex-direction: row;
	padding: 0 rem(120);
	gap: rem(40);

	.detect_deviece_mobile & {
		flex-direction: column;
		padding: 0 rem(16);
		gap: rem(36);
	}
}

.qualification-container {
	flex: 1;
}

.qualification-title,
.pros-cons-title {
	color: #1a4048;
	font-size: rem(24);
	line-height: rem(28);
	font-weight: 700;
	margin-bottom: rem(24);

	.detect_deviece_mobile & {
		font-size: rem(20);
		line-height: rem(20);
		font-weight: 900;
		margin-bottom: rem(24);
	}
}

.qualification-list {
	list-style-type: none;
	padding: 0;
	margin: 0;
}

.qulification-dashed {
	border-left: 1px dashed rgba(26, 64, 72, 0.3);
}

.qualification-item {
	color: #1a4048;
	font-size: rem(16);
	line-height: rem(24);
	padding-left: rem(24);
	position: relative;
	margin-bottom: rem(16);

	&:before {
		content: '';
		width: rem(8);
		height: rem(8);
		border-radius: 50%;
		background: #1a4048;
		position: absolute;
		left: 0;
		top: rem(8);
	}

	.detect_deviece_mobile & {
		font-size: rem(12);
		line-height: rem(16);
		margin-bottom: rem(12);
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
	}
}

.pros-cons-container {
	flex: 2;
	display: flex;
	gap: rem(20);

	.detect_deviece_mobile & {
		flex-direction: column;
	}
}

.pros-container,
.cons-container {
	flex: 1;
}

.pros-list,
.cons-list {
	list-style-type: none;
	padding: 0;
	margin: 0;
}

.pros-item,
.cons-item {
	display: flex;
	align-items: flex-start;
	gap: rem(12);
	margin-bottom: rem(16);
	color: #1a4048;
	font-size: rem(16);
	line-height: rem(24);

	.detect_deviece_mobile & {
		font-size: rem(12);
		line-height: rem(16);
		margin-bottom: rem(12);
		height: rem(32);
		align-items: center;
	}
}

.check-icon,
.x-icon {
	flex-shrink: 0;
	width: rem(16);
	height: rem(16);
	margin-top: rem(4);
}

/* 摘要部分 */
.summary-section {
	padding: 0 rem(120);

	.detect_deviece_mobile & {
		padding: 0 rem(16);
	}
}

.summary-title {
	color: #1a4048;
	font-size: rem(24);
	line-height: rem(28);
	font-weight: 700;
	margin-bottom: rem(16);

	.detect_deviece_mobile & {
		font-size: rem(20);
		line-height: rem(20);
		font-weight: 900;
		margin-bottom: rem(24);
	}
}

.summary-content {
	color: #1a4048;
	font-size: rem(16);
	line-height: rem(24);

	.detect_deviece_mobile & {
		font-size: rem(12);
		line-height: rem(16);
	}
}

/* 其他贷款机构推荐 */
.other-lenders-section {
	padding: 0 rem(120) rem(60);

	.detect_deviece_mobile & {
		padding: 0 rem(16) rem(36);
	}
}

.other-lenders-header {
	padding-bottom: rem(24);
	display: flex;
	flex-direction: column;
	gap: rem(20);
	align-items: flex-start;
	justify-content: flex-start;

	.detect_deviece_mobile & {
		height: auto;
		padding: rem(36) 0 rem(24) 0;
	}
}

.other-lenders-header-title {
	color: #1a4048;
	font-size: rem(24);
	line-height: rem(24);
	font-weight: 900;
	text-align: left;

	.detect_deviece_mobile & {
		font-size: rem(20);
		line-height: rem(20);
		text-align: left;
	}
}

.other-lenders-divider {
	background: var(--theme-primary);
	border-radius: rem(100);
	width: rem(36);
	height: rem(4);
}

/* 重用HomeLenders样式 */
.other-lenders-container {
	position: relative;
}

.lenders-cards-container {
	position: relative;
	overflow: hidden;
}

.lenders-cards {
	display: flex;
	transition: transform 0.5s ease;
}

.lenders-group {
	display: flex;
	// justify-content: space-between;
	gap: rem(20);
	min-width: 100%;

	.detect_deviece_mobile & {
		flex-direction: column;
		align-items: center;
		gap: rem(16);
	}
}

.lender-card {
	background: #f8fcfd;
	border-radius: rem(20);
	border: rem(1) solid #e6f6f9;
	padding: rem(20);
	width: calc(33.33% - rem(14));
	cursor: pointer;

	&:hover {
		border: rem(2) solid #1a4048;
	}

	.detect_deviece_mobile & {
		width: 100%;
		margin-bottom: 0;
		background: linear-gradient(180deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
	}
}

.lender-logo-container-card {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-bottom: rem(24);
	gap: rem(12);

	.detect_deviece_mobile & {
		margin-bottom: rem(20);
		gap: rem(20);
	}
}

.lender-card {
	.lender-logo {
		width: rem(80);
		height: rem(80);
		border-radius: rem(16);
		background: #ffffff;
		border: rem(1) solid #e6f6f9;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 0;
	}

	.logo-img {
		width: rem(60);
		height: rem(60);
		object-fit: contain;
		border-radius: rem(8);
	}

	.logo-placeholder {
		width: rem(60);
		height: rem(60);
		border-radius: rem(8);
		background: #cccccc;
	}

	.lender-info {
		display: flex;
		flex-direction: column;
	}

	.lender-name {
		color: #1a4048;
		font-size: rem(24);
		line-height: rem(28);
		font-weight: 700;
		margin-bottom: rem(8);

		.detect_deviece_mobile & {
			margin-bottom: rem(16);
		}
	}

	.lender-rating {
		display: flex;
		align-items: center;
		gap: rem(4);
		background: #f6c33f;
		border-radius: rem(100);
		padding: rem(4) rem(12);
		width: fit-content;

		.star-icon {
			width: rem(12);
			height: rem(12);
			color: #ffffff;
		}

		span {
			color: #fff;
			font-size: rem(14);
			line-height: rem(14);
			font-weight: 700;
		}
	}
}

.lender-card {
	.divider {
		height: rem(1);
		margin: 0 0 rem(24);
		background: #e5e7eb;

		.detect_deviece_mobile & {
			margin-bottom: rem(20);
		}
	}
}

.lender-card {
	.lender-details {
		display: flex;
		flex-direction: column;
		gap: rem(16);

		.detect_deviece_mobile & {
			gap: rem(24);
		}
	}
}

.lender-card {
	.detail-item {
		display: flex;
		align-items: center;
		gap: rem(12);
	}
}

.lender-card {
	.detail-icon {
		width: rem(44);
		height: rem(44);
		border-radius: rem(100);
		background: var(--theme-primary);
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: rem(24);
			height: rem(24);
			flex-shrink: 0;
			color: #ffffff;
		}

		.detect_deviece_mobile & {
			width: rem(56);
			height: rem(56);

			img {
				width: rem(28);
				height: rem(28);
			}
		}
	}
}

.lender-card {
	.detail-content {
		display: flex;
		flex-direction: column;
	}
}

.lender-card {
	.detail-label {
		color: #1a4048;
		font-size: rem(14);
		line-height: rem(16);
		font-weight: 400;
		margin-bottom: rem(4);

		.detect_deviece_mobile & {
			margin-bottom: rem(8);
		}
	}
}

.lender-card {
	.detail-value {
		color: #1a4048;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 700;

		.detect_deviece_mobile & {
			font-size: rem(20);
			line-height: rem(20);
		}
	}
}

.navigation-controls {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: rem(40);
	gap: rem(20);
}

.nav-button {
	width: rem(28);
	height: rem(28);
	border-radius: rem(100);
	background: #1a4048;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: background-color 0.3s ease;

	img {
		width: rem(6);
		height: rem(12);
		color: #ffffff;
	}

	&:hover {
		background-color: var(--theme-primary);

		img {
			color: #ffffff;
		}
	}

	&.disabled {
		opacity: 0.5;
		cursor: not-allowed;

		&:hover {
			background: #1a4048;

			img {
				color: #ffffff;
			}
		}
	}
}

.pagination-dots {
	display: flex;
	gap: rem(8);
}

.pagination-dot {
	width: rem(8);
	height: rem(8);
	border-radius: 50%;
	background: #e6f6f9;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&.active {
		background: #1a4048;
	}

	&:hover:not(.active) {
		background: #66cee4;
	}
}
</style> 